import { useQuery } from "@apollo/client"
import { GET_ALL_TERMINALS } from "../graphql/queries/getAllTerminals"
import { GET_ADDRESS_VALIDATION_RULES } from "../graphql-saleor/queries/getAddressValidationRules"
import { client } from "../graphql-saleor/client"

export const useAddressValidationRules = (countryCode: string) => {
  const { data, error, loading, refetch } = useQuery(GET_ADDRESS_VALIDATION_RULES, {
    client: client,
    variables: {
      countryCode: countryCode,
    },
  })
  return {
    addressValidationRules: data?.addressValidationRules,
    error,
    isLoading: loading,
    refetch,
  }
}
